module.exports = __webpack_public_path__ + "img/edit-white.50f694e4.svg";